import * as d3 from 'd3'

export default {
  methods: {
    

    call_LINK(selection, _filter , d_, _st) {
      if(_filter == '') return
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(100).attr('opacity', 0.5)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(200).attr('opacity', 1)
      })
      .on('click', () => {
        this.link_Modal(d_,this.filters[_filter])
      }) 
    }, 

    link_Modal(d_, col_) {

      let dataSource = {}

      Object.keys(this.keys).forEach(d=>{
        dataSource = {...dataSource, [d]: d_[this.keys[d]]}
      })
      

      // set for request from A/G jsonProps
      let request_ = this.getRequestColumnProps('request', dataSource, this.ColumnProps)
      if(!request_) return

      // set for filterString 
      let filterString_ = col_ || ''

      if (col_.type == 'fab') {
        filterString_ = `[S_OUT] IS NOT NULL`
      } else if (col_.type == 'install') {
        filterString_ = `[INSTALL_DATE] IS NOT NULL`
      }

      // if A/G filterString is exist, set request_.iFilters.filterString + filterString_
      if(request_.iFilters.filterString) {
        request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
      } else {
        request_.iFilters.filterString = filterString_||''
      }

      // combine filterString and inputFilter &&& emit request-action
      request_ = {...request_,
        filters : {
          ...this.FilterValues,
          ...request_.filters,
        },
        iFilters: { 
          filterString : request_.iFilters.filterString||'',
          inputFilter : request_.iFilters.inputFilter,},
      }
      this.$emit('request-action', request_)
    },
 
    
  }
}